import { Injectable } from '@angular/core';
import { connect, Room } from 'twilio-video';

export enum RoomEvents {
  DISCONNECTED = 'disconnected',
  PARTICIPANT_CONNECTED = 'participantConnected',
  PARTICIPANT_DISCONNECTED = 'participantDisconnected',
  DOMINANT_SPEAKER_CHANGE = 'dominantSpeakerChanged',
  SCREEN_SHARE_STOPPED = 'stopped',
  TRACK_ENABLED = 'trackEnabled',
  TRACK_DISABLED = 'trackDisabled',
}

@Injectable()
export class ConnectRoomService {
  public activeRoom: Room;

  public async joinRoom(twilioToken: string, twilioRoomName: string) {
    return await connect(twilioToken, {
      name: twilioRoomName,
      dominantSpeaker: true,
    });
  }
}
